import { render, staticRenderFns } from "./AdminOrderManage.vue?vue&type=template&id=dde1469e&"
import script from "./AdminOrderManage.vue?vue&type=script&lang=js&"
export * from "./AdminOrderManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports